
import React from 'react';
import { JUVCard } from '@/components/juv';
import { Sparkle } from 'lucide-react';
import TreatmentTable from './TreatmentTable';
import TooltipText from './TooltipText';

const LaserTreatmentsSection = () => {
  const treatments = [
    {
      name: 'SmoothEye',
      member: '$250',
      visitor: '$350',
      tooltip: 'Non-surgical eye lift that tightens and brightens'
    },
    {
      name: 'LipLase',
      member: '$250',
      visitor: '$350',
      tooltip: 'Laser lip plumping for a fuller look without filler'
    },
    {
      name: 'Laser Skin Rejuvenation',
      member: '$275',
      visitor: '$350',
      tooltip: 'Full-face tone and texture enhancement'
    },
    {
      name: 'Fotona 4D',
      member: '$699',
      visitor: '$1,050',
      tooltip: 'Complete skin tightening and resurfacing protocol'
    },
    {
      name: 'HairLase',
      member: '$350',
      visitor: '$450',
      tooltip: 'Stimulates hair follicles to support regrowth'
    }
  ];

  const headers = ['Treatment', 'Member', 'Visitor'];

  return (
    <JUVCard
      title="🔬 Laser Treatments (Fotona Technology)"
      icon={Sparkle}
      variant="glass"
      className="mb-8"
    >
      <TreatmentTable
        headers={headers}
        treatments={treatments}
        showTooltips={true}
      />
    </JUVCard>
  );
};

export default LaserTreatmentsSection;
